import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { Grid } from '@mui/material'
import { useGlobalStore } from '../../../../store'
import { MuiTextField, MuiSelect, MuiButton, AccordionWithArrow, Loader } from '../../../../components' // MessageReactQuery
// import { Rte } from '../../../../components'
import forumService from '../../../../services/forum.service'
// import { useReactQuery } from '../../../../hooks/useReactQuery'
import { getObjectAsArray, defaultSelectObj, trimData, htmlEntitiesFunc } from '../../../../util'
import { GridWrapper, GridFooter, Hr } from './style'

const KeywordVibeMapping = ({ data, mode, onChange, expanded }) => {
  const { company } = useGlobalStore()
  const defaultData = { keywordId: '', keyword: '', subKeywordLevel1: '', subKeywordLevel2: '', vibe: '', notes: '', type: '', subType: '', mediaLink: '', s3Name: '', verbatim: '' }

  const defaultDataFunc = (d) => {
    return {
      keywordId: d?.KeywordId || '',
      keyword: d?.KeywordValue || '',
      keywordSearchTerm: d?.KeywordSearchTerm || '',
      subKeywordLevel1: trimData(d?.SubKeywordLevel1) || '',
      subKeywordLevel1Array: [],
      subKeywordLevel2: trimData(d?.SubKeywordLevel2) || '',
      subKeywordLevel2Array: [],
      vibe: d?.KeywordVibe || '',
      notes: d?.KeywordNotes || '',
      type: trimData(d?.KeywordType) || '',
      typeSelectArray: [],
      subType: trimData(d?.KeywordSubType) || '',
      subTypeSelectArray: [],
      mediaLink: d?.KeywordVerbatimMediaPublicLink || '',
      s3Name: d?.KeywordVerbatimMediaPrivateName || '',
      // verbatim: d?.KeywordVerbatim?.replaceAll('&amp;', '&')?.replaceAll('&lt;', '<')?.replaceAll('&gt;', '>')?.replaceAll('&quot;', '"')?.replaceAll('&nbsp;', ' ') || ''
      verbatim: htmlEntitiesFunc(d?.KeywordVerbatim) || ''
    }
  }
  const [formSectionData, setFormSectionData] = useState(data.map(d => defaultDataFunc(d)))
  // const [isLoadedKeywordsArray, setIsLoadedKeywordsArray] = useState([])

  const [isFormSelectDataLoaded, setIsFormSelectDataLoaded] = useState(false)
  const [count, setCount] = useState(0)
  const [formSelectData, setFormSelectData] = useState({
    keyword: [],
    subKeywordLevel1: [],
    subKeywordLevel2: [],
    vibe: [],
    notes: [],
    type: [],
    subType: []
  })

  /*
  const useReactQueryObject1 = {
    payloadDetails: {
      queryId: ['Keywords'],
      urlFunc: forumService.getOrganizationAggregationKeywordsApi,
      payload: { organizationId: company?.OrganizationId }
    },
    useReactQueryObject: { cacheTime: 10000 }
  }
  const useReactQueryObject2 = {
    payloadDetails: {
      queryId: ['Notes'],
      urlFunc: forumService.getOrganizationAggregationKeywordNotesApi,
      payload: { organizationId: company?.OrganizationId }
    },
    useReactQueryObject: { cacheTime: 10000 }
  }
  // const useReactQueryObject5 = {
  //   payloadDetails: {
  //     queryId: ['Notes', 'Types'],
  //     urlFunc: forumService.getOrganizationAggregationKeywordTypesForNotesApi,
  //     payload: { organizationId: company?.OrganizationId }
  //   },
  //   useReactQueryObject: {
  //     enabled: false
  //   }
  // }
  // const useReactQueryObject6 = {
  //   payloadDetails: {
  //     queryId: ['Notes', 'Types', 'SubTypes'],
  //     urlFunc: forumService.getOrganizationAggregationKeywordSubTypesForNotesTypeApi,
  //     payload: { organizationId: company?.OrganizationId }
  //   },
  //   useReactQueryObject: {
  //     enabled: false
  //   }
  // }
  const { data: data1, isLoading: isLoading1, isSuccess: isSuccess1, isError: isError1, error: error1 } = useReactQuery(useReactQueryObject1)
  const { data: data2, isLoading: isLoading2, isSuccess: isSuccess2, isError: isError2, error: error2 } = useReactQuery(useReactQueryObject2)
  // const { data: data5, isLoading: isLoading5, isSuccess: isSuccess5, isError: isError5, error: error5 } = useReactQuery(useReactQueryObject5)
  // const { data: data6, isLoading: isLoading6, isSuccess: isSuccess6, isError: isError6, error: error6, refetch: refetch6 } = useReactQuery(useReactQueryObject6)
  */

  const onChangeHandler = async (key, index, value) => {
    const obj = {
      ...formSectionData[index],
      [key]: value
    }

    if (key === 'keyword') {
      const selectedObj = formSelectData.keyword.filter(f => f.label === value)[0]
      obj.keywordId = selectedObj.valKeywordId
      obj.keywordSearchTerm = selectedObj.valKeywordSearchTerm
    }

    const array = formSectionData
    array[index] = obj

    setFormSectionData([...array])
  }

  const addMoreFunc = () => {
    const array = [...formSectionData]
    array.push(defaultData)
    setFormSectionData(array)
  }

  /*
  const removeFunc = () => {
    const array = [...formSectionData]
    array.pop()
    setFormSectionData(array)
  }
  */

  const onload = async () => {
    const payload = { organizationId: company?.OrganizationId }
    const keywordApi = await forumService.getOrganizationAggregationKeywordsApi(payload)
    const keywordArray = getObjectAsArray(keywordApi).map(d => ({ label: trimData(d.KeywordValue), value: trimData(d.KeywordValue), valKeywordValue: trimData(d.KeywordValue), valKeywordId: d.KeywordId, valKeywordSearchTerm: d.KeywordSearchTerm }))
    keywordArray.push({ label: 'Dummy', value: 'Dummy', valKeywordValue: 'Dummy', valKeywordId: 'Dummy', valKeywordSearchTerm: 'Dummy' })
    keywordArray.push({ label: ' ', value: ' ', valKeywordValue: ' ', valKeywordId: ' ', valKeywordSearchTerm: ' ' })

    const notesApi = await forumService.getOrganizationAggregationKeywordNotesApi(payload)
    const notesArray = getObjectAsArray(notesApi).reduce((oldVal, newVal) => ([...oldVal, { label: trimData(newVal), value: trimData(newVal) }]), [])
    notesArray.push({ label: 'Dummy', value: 'Dummy' })
    notesArray.push({ label: '', value: '' })

    const vibeArray = [{ value: null, label: '' }, { label: 'Neutral', value: 'Neutral' }, { label: 'Positive', value: 'Positive' }, { label: 'Negative', value: 'Negative' }, { label: 'Mixed', value: 'Mixed' }]

    // setFormSelectData(prev => ({ ...prev, keyword: keywordArray, notes: notesArray, type: typesArray, subType: subTypesArray, vibe: vibeArray }))
    setFormSelectData(prev => ({ ...prev, keyword: keywordArray, notes: notesArray, vibe: vibeArray }))
    // setFormSelectData(prev => ({ ...prev, vibe: vibeArray }))
    onChange(formSectionData)

    // loadSubLevel1AndSubLevel2Func(0) // WIP
    // loadTypesAndSubTypesFunc(0)

    loadAllNestedDropdownFunc(0)
  }

  const loadSubLevel1AndSubLevel2Func2 = async (obj, i) => {
    const arrayCount = { subLevel1: 0, subLevel2: 0 }
    // consoleLog('obj ', obj)

    if (obj.subKeywordLevel1 !== '') {
      const payload1 = { organizationId: company?.OrganizationId, keywordValue: obj.keyword }
      const typesApi = await forumService.getOrganizationAggregationSubKeywordLevel1ForKeywordApi(payload1)
      const tempTypesArray = getObjectAsArray(typesApi, 'adv')
      const typesArray = [defaultSelectObj.empty]
      for (let t = 0; t < tempTypesArray.length; t++) {
        const txt = trimData(tempTypesArray[t])
        typesArray.push({ label: txt, value: txt })
      }

      typesArray.push({ label: 'Dummy', value: 'Dummy' })
      typesArray.push({ label: 'NA', value: 'NA' })
      typesArray.push({ label: '', value: '' })
      obj.subKeywordLevel1Array = typesArray
      arrayCount.subLevel1 = typesArray.length
    } else {
      const typesArray = [defaultSelectObj.empty, { label: 'Dummy', value: 'Dummy' }, { label: 'NA', value: 'NA' }, { label: '', value: '' }]
      obj.subKeywordLevel1Array = typesArray
      arrayCount.subLevel1 = typesArray.length
    }

    if (obj.subKeywordLevel2 !== '') {
      // const payload2 = { organizationId: company?.OrganizationId, notes: obj.notes, keywordType: obj.type }
      // const subTypesApi = await forumService.getOrganizationAggregationKeywordSubTypesForNotesTypeApi(payload2)
      const payload2 = { organizationId: company?.OrganizationId, keywordValue: obj.keyword, subKeywordLevel1Value: obj.subKeywordLevel1 }
      const subTypesApi = await forumService.getOrganizationAggregationSubKeywordLevel2ForKeywordLevel1Api(payload2)
      const tempSubTypesArray = getObjectAsArray(subTypesApi, 'adv')
      const subTypesArray = [defaultSelectObj.empty]
      for (let t = 0; t < tempSubTypesArray.length; t++) {
        const txt = trimData(tempSubTypesArray[t])
        subTypesArray.push({ label: txt, value: txt })
      }

      subTypesArray.push({ label: 'Dummy', value: 'Dummy' })
      subTypesArray.push({ label: 'NA', value: 'NA' })
      subTypesArray.push({ label: '', value: '' })
      obj.subKeywordLevel2Array = subTypesArray
      arrayCount.subLevel2 = subTypesArray.length
    } else {
      const subTypesArray = [defaultSelectObj.empty, { label: 'Dummy', value: 'Dummy' }, { label: 'NA', value: 'NA' }, { label: '', value: '' }]
      obj.subKeywordLevel2Array = subTypesArray
      arrayCount.subLevel2 = subTypesArray.length
    }

    const tempFormSectionData = formSectionData
    tempFormSectionData[i].subKeywordLevel1Array = obj.subKeywordLevel1Array
    tempFormSectionData[i].subKeywordLevel2Array = obj.subKeywordLevel2Array

    // SULAMAN SULAMAN

    setCount(prev => prev + 1)

    if (i === formSectionData.length - 1) {
      setIsFormSelectDataLoaded(true)
    }
    // }, 10)
  }

  /*
  const loadSubLevel1AndSubLevel2Func = async (index) => {
    const formSectionDataArray = [...formSectionData]
    for (let i = 0; i < formSectionDataArray.length; i++) {
      await loadSubLevel1AndSubLevel2Func2(formSectionDataArray[i], i)
    }
    if (formSectionDataArray.length === 0) {
      setIsFormSelectDataLoaded(true)
      addMoreFunc()
    }
  }
  */

  const loadTypesAndSubTypesFunc2 = async (obj, i) => {
    // setTimeout(async () => {
    const arrayCount = { types: 0, subType: 0 }
    if (obj.notes !== '') {
      const payload1 = { organizationId: company?.OrganizationId, notes: obj.notes }
      const typesApi = await forumService.getOrganizationAggregationKeywordTypesForNotesApi(payload1)
      const tempTypesArray = getObjectAsArray(typesApi, 'adv')
      const typesArray = [defaultSelectObj.empty]
      for (let t = 0; t < tempTypesArray.length; t++) {
        // const txt = (tempTypesArray[t]).replaceAll('/t', '').replaceAll('\/t', '')
        const txt = trimData(tempTypesArray[t])
        typesArray.push({ label: txt, value: txt })
      }

      typesArray.push({ label: 'Dummy', value: 'Dummy' })
      typesArray.push({ label: 'NA', value: 'NA' })
      typesArray.push({ label: '', value: '' })
      obj.typeSelectArray = typesArray
      arrayCount.types = typesArray.length
    } else {
      const typesArray = [defaultSelectObj.empty, { label: 'Dummy', value: 'Dummy' }, { label: 'NA', value: 'NA' }, { label: '', value: '' }]
      obj.typeSelectArray = typesArray
      arrayCount.types = typesArray.length
    }

    if (obj.type !== '') {
      const payload2 = { organizationId: company?.OrganizationId, notes: obj.notes, keywordType: obj.type }
      const subTypesApi = await forumService.getOrganizationAggregationKeywordSubTypesForNotesTypeApi(payload2)
      const tempSubTypesArray = getObjectAsArray(subTypesApi, 'adv')
      const subTypesArray = [defaultSelectObj.empty]
      for (let t = 0; t < tempSubTypesArray.length; t++) {
        const txt = trimData(tempSubTypesArray[t])
        subTypesArray.push({ label: txt, value: txt })
      }

      subTypesArray.push({ label: 'Dummy', value: 'Dummy' })
      subTypesArray.push({ label: 'NA', value: 'NA' })
      subTypesArray.push({ label: '', value: '' })
      obj.subTypeSelectArray = subTypesArray
      arrayCount.subType = subTypesArray.length
    } else {
      const subTypesArray = [defaultSelectObj.empty, { label: 'Dummy', value: 'Dummy' }, { label: 'NA', value: 'NA' }, { label: '', value: '' }]
      obj.subTypeSelectArray = subTypesArray
      arrayCount.subType = subTypesArray.length
    }

    const tempFormSectionData = formSectionData
    tempFormSectionData[i].typeSelectArray = obj.typeSelectArray
    tempFormSectionData[i].subTypeSelectArray = obj.subTypeSelectArray

    setCount(prev => prev + 1)

    if (i === formSectionData.length - 1) {
      setIsFormSelectDataLoaded(true)
    }
    // }, 10)
  }

  /*
  const loadTypesAndSubTypesFunc = async (index) => {
    const formSectionDataArray = [...formSectionData]
    for (let i = 0; i < formSectionDataArray.length; i++) {
      await loadTypesAndSubTypesFunc2(formSectionDataArray[i], i)
    }
    if (formSectionDataArray.length === 0) {
      setIsFormSelectDataLoaded(true)
      addMoreFunc()
    }
  }
  */

  const loadAllNestedDropdownFunc = async (index) => {
    const formSectionDataArray = [...formSectionData]
    for (let i = 0; i < formSectionDataArray.length; i++) {
      await loadTypesAndSubTypesFunc2(formSectionDataArray[i], i)
      await loadSubLevel1AndSubLevel2Func2(formSectionDataArray[i], i)
    }
    if (formSectionDataArray.length === 0) {
      setIsFormSelectDataLoaded(true)
      addMoreFunc()
    }
  }

  const onKeywordChange = async (value, i) => {
    onChangeHandler('keyword', i, value)
    const payload = { organizationId: company?.OrganizationId, keywordValue: value }
    const typesApi = await forumService.getOrganizationAggregationSubKeywordLevel1ForKeywordApi(payload)
    const typesArray = getObjectAsArray(typesApi, 'adv').reduce((oldVal, newVal) => ([...oldVal, { label: trimData(newVal), value: trimData(newVal) }]), [])
    typesArray.push({ label: 'Dummy', value: 'Dummy' })
    typesArray.push({ label: 'NA', value: 'NA' })
    typesArray.push({ label: '', value: '' })
    const formSectionDataArray = formSectionData
    formSectionDataArray[i].subKeywordLevel1Array = typesArray
    formSectionDataArray[i].subKeywordLevel2Array = []
    setFormSectionData(formSectionDataArray)
  }

  const onSubKeywordLevel1Change = async (value, i) => {
    onChangeHandler('subKeywordLevel1', i, value)
    const payload = { organizationId: company?.OrganizationId, keywordValue: formSectionData[i].keyword, subKeywordLevel1Value: value }
    const typesApi = await forumService.getOrganizationAggregationSubKeywordLevel2ForKeywordLevel1Api(payload)
    const typesArray = getObjectAsArray(typesApi, 'adv').reduce((oldVal, newVal) => ([...oldVal, { label: trimData(newVal), value: trimData(newVal) }]), [])
    typesArray.push({ label: 'Dummy', value: 'Dummy' })
    typesArray.push({ label: 'NA', value: 'NA' })
    typesArray.push({ label: '', value: '' })
    const formSectionDataArray = formSectionData
    formSectionDataArray[i].subKeywordLevel2Array = typesArray
    setFormSectionData(formSectionDataArray)
  }

  const onNotesChange = async (value, i) => {
    /*
    onChangeHandler('notes', i, value)
    useReactQueryObject5.payloadDetails.queryId = ['SM', 'Notes-' + i, value, 'Types']
    useReactQueryObject5.payloadDetails.payload = { organizationId: company?.OrganizationId, notes: value }
    consoleLog('useReactQueryObject5.payloadDetails = ', useReactQueryObject5.payloadDetails, ' || ', value, i)
    refetch5()
    */

    onChangeHandler('notes', i, value)
    const payload = { organizationId: company?.OrganizationId, notes: value }
    const typesApi = await forumService.getOrganizationAggregationKeywordTypesForNotesApi(payload)
    const typesArray = getObjectAsArray(typesApi, 'adv').reduce((oldVal, newVal) => ([...oldVal, { label: trimData(newVal), value: trimData(newVal) }]), [])
    typesArray.push({ label: 'Dummy', value: 'Dummy' })
    typesArray.push({ label: 'NA', value: 'NA' })
    typesArray.push({ label: '', value: '' })
    const formSectionDataArray = formSectionData
    formSectionDataArray[i].typeSelectArray = typesArray
    formSectionDataArray[i].subTypeSelectArray = []
    setFormSectionData(formSectionDataArray)
    /**/
  }

  const onTypeChange = async (value, i) => {
    onChangeHandler('type', i, value)
    const payload = { organizationId: company?.OrganizationId, notes: formSectionData[i].notes, keywordType: value }
    const typesApi = await forumService.getOrganizationAggregationKeywordSubTypesForNotesTypeApi(payload)
    const typesArray = getObjectAsArray(typesApi, 'adv').reduce((oldVal, newVal) => ([...oldVal, { label: trimData(newVal), value: trimData(newVal) }]), [])
    typesArray.push({ label: 'Dummy', value: 'Dummy' })
    typesArray.push({ label: 'NA', value: 'NA' })
    typesArray.push({ label: '', value: '' })
    const formSectionDataArray = formSectionData
    formSectionDataArray[i].subTypeSelectArray = typesArray
    setFormSectionData(formSectionDataArray)
  }

  const hasDataAndNotDisabled = (value) => {
    if (mode) { return (value?.length > 0) && mode }
    return true
  }

  useEffect(() => {
    onChange(formSectionData)
  }, [formSectionData])

  useEffect(() => {
    onload()
  }, [])

  /*
  const onSuccess1Func = (resp) => {
    const keywordArray = getObjectAsArray(resp).map(d => ({ label: trimData(d.KeywordValue), value: trimData(d.KeywordValue), valKeywordValue: trimData(d.KeywordValue), valKeywordId: d.KeywordId, valKeywordSearchTerm: d.KeywordSearchTerm }))
    keywordArray.push({ label: 'Dummy', value: 'Dummy', valKeywordValue: 'Dummy', valKeywordId: 'Dummy', valKeywordSearchTerm: 'Dummy' })
    keywordArray.push({ label: ' ', value: ' ', valKeywordValue: ' ', valKeywordId: ' ', valKeywordSearchTerm: ' ' })
    setFormSelectData(prev => ({ ...prev, keyword: keywordArray }))
  }
  useEffect(() => {
    if (isSuccess1 && data1?.length) onSuccess1Func(data1)
  }, [isSuccess1, data1])

  const onSuccess2Func = (resp) => {
    const notesArray = getObjectAsArray(resp).reduce((oldVal, newVal) => ([...oldVal, { label: trimData(newVal), value: trimData(newVal) }]), [])
    notesArray.push({ label: 'Dummy', value: 'Dummy' })
    notesArray.push({ label: '', value: '' })
    setFormSelectData(prev => ({ ...prev, notes: notesArray }))
  }
  useEffect(() => {
    if (isSuccess2 && data2?.length) onSuccess2Func(data2)
  }, [isSuccess2, data2])
  /** */

  /*
  const onSuccess5Func = (resp) => {
    const i = useReactQueryObject5.payloadDetails.queryId[0].split('-')[1] // ['Notes-' + i, value, 'Types']
    consoleLog('onSuccess5Func = (resp)', resp, '|', i, '|', useReactQueryObject5.payloadDetails.queryId)
    // const typesArray = getObjectAsArray(resp, 'adv').reduce((oldVal, newVal) => ([...oldVal, { label: trimData(newVal), value: trimData(newVal) }]), [])
    // typesArray.push({ label: 'Dummy', value: 'Dummy' })
    // typesArray.push({ label: 'NA', value: 'NA' })
    // typesArray.push({ label: '', value: '' })
    // const formSectionDataArray = formSectionData
    // formSectionDataArray[i].typeSelectArray = typesArray
    // formSectionDataArray[i].subTypeSelectArray = []
    // setFormSectionData(formSectionDataArray)
  }
  useEffect(() => {
    if (isSuccess5 && data5?.length) onSuccess5Func(data5)
  }, [isSuccess5, data5])
  */

  return (
    <AccordionWithArrow title='Keyword Vibe Mapping' expanded={expanded} accordionstyle='fieldset' showOverlay={mode}>
      {/* <MessageReactQuery
        isLoading={isLoading1 || isLoading2}
        isSuccess={isSuccess1 || isSuccess2}
        data={data1 || data2}
        isError={isError1 || isError2}
        error={error1 || error2}
      /> */}
      <GridWrapper>
        {isFormSelectDataLoaded && formSectionData?.length > 0 && count + 1 && formSectionData.map((formData, i) => {
          return (
            <Grid className='gridInnerWrapper' key={'keywordVibeMap__' + i} container spacing={2} data-sr={i + 1}>
              {hasDataAndNotDisabled(formData.keyword) && formSelectData.keyword?.length > 0 && <Grid item xs={3}>
                <MuiSelect
                  data={formSelectData.keyword}
                  name='keyword'
                  // label='Keyword'
                  placeholder='Keyword'
                  // onChange={(e) => onChangeHandler('keyword', i, e.target.value)}
                  onChange={(e) => onKeywordChange(e.target.value, i)}
                  variant='standard'
                  value={formData.keyword}
                  disabled={mode}
                />
              </Grid>}
              {/* {hasDataAndNotDisabled(formData.subKeywordLevel1Array) && formSelectData.subKeywordLevel1?.length > 0 && <Grid item xs={3}> */}
              {hasDataAndNotDisabled(formData.subKeywordLevel1) && formData?.subKeywordLevel1Array?.length > 0 && <Grid item xs={3}>
                <MuiSelect
                  // data={formSelectData.subKeywordLevel1}
                  data={formData.subKeywordLevel1Array}
                  name='subKeywordLevel1'
                  // label='Sub Keyword Level 1'
                  placeholder='Sub Keyword Level 1'
                  // onChange={(e) => onChangeHandler('subKeywordLevel1', i, e.target.value)}
                  onChange={(e) => onSubKeywordLevel1Change(e.target.value, i)}
                  variant='standard'
                  value={formData.subKeywordLevel1}
                  disabled={mode}
                />
              </Grid>}
              {/* {hasDataAndNotDisabled(formData.subKeywordLevel2Array) && formSelectData.subKeywordLevel2?.length > 0 && <Grid item xs={3}> */}
              {hasDataAndNotDisabled(formData.subKeywordLevel2) && formData?.subKeywordLevel2Array?.length > 0 && <Grid item xs={3}>
                <MuiSelect
                  // data={formSelectData.subKeywordLevel2}
                  data={formData.subKeywordLevel2Array}
                  name='subKeywordLevel2'
                  // label='Sub Keyword Level 2'
                  placeholder='Sub Keyword Level 2'
                  onChange={(e) => onChangeHandler('subKeywordLevel2', i, e.target.value)}
                  variant='standard'
                  value={formData.subKeywordLevel2}
                  disabled={mode}
                />
              </Grid>}
              {hasDataAndNotDisabled(formData.vibe) && formSelectData.vibe?.length > 0 && <Grid item xs={3}>
                <MuiSelect
                  data={formSelectData.vibe}
                  name='vibe'
                  // label='Vibe'
                  placeholder='Vibe'
                  onChange={(e) => onChangeHandler('vibe', i, e.target.value)}
                  variant='standard'
                  value={formData.vibe || ''}
                  disabled={mode}
                />
              </Grid>}
              <Grid item xs={12} sx={{ padding: 0 }}></Grid>
              {hasDataAndNotDisabled(formData.notes) && formSelectData?.notes?.length > 0 && <Grid item xs={3}>
                <MuiSelect
                  data={formSelectData.notes}
                  name='notes'
                  // label='Notes'
                  placeholder='Notes'
                  // onChange={(e) => onChangeHandler('notes', i, e.target.value)}
                  onChange={(e) => onNotesChange(e.target.value, i)}
                  variant='standard'
                  value={formData.notes || ''}
                  disabled={mode}
                />
              </Grid>}
              {hasDataAndNotDisabled(formData.type) && formData?.typeSelectArray?.length > 0 && <Grid item xs={3}>
                <MuiSelect
                  // data={formSelectData.type}
                  data={formData.typeSelectArray}
                  name='type'
                  // label='Type'
                  placeholder='Type'
                  // onChange={(e) => onChangeHandler('type', i, e.target.value)}
                  onChange={(e) => onTypeChange(e.target.value, i)}
                  variant='standard'
                  value={formData.type || ''}
                  disabled={mode}
                />
              </Grid>}
              {hasDataAndNotDisabled(formData.subType) && formData?.subTypeSelectArray?.length > 0 && <Grid item xs={3}>
                <MuiSelect
                  // data={formSelectData.subType}
                  data={formData.subTypeSelectArray}
                  name='subType'
                  // label='Sub Type'
                  placeholder='Sub Type'
                  onChange={(e) => onChangeHandler('subType', i, e.target.value)}
                  variant='standard'
                  value={formData.subType || ''}
                  disabled={mode}
                />
              </Grid>}
              {hasDataAndNotDisabled(formData.verbatim) && <Grid item xs={12}>
                <MuiTextField
                  name='verbatim'
                  // label='Verbatim'
                  placeholder='Verbatim'
                  onChange={(e) => onChangeHandler('verbatim', i, e.target.value)}
                  variant='standard'
                  value={formData.verbatim || ''}
                  disabled={mode}
                  multiline
                  // rows={1}
                  maxRows={10}
                />
                {/* <Rte
                  title=''
                  value={formData.verbatim || ''}
                  // onChange={(e) => consoleLog(e)}
                  onChange={(e) => onChangeHandler('verbatim', i, e)}
                  height={200}
                  toolbarShow={false}
                  customToolbar={'bold'}
                /> */}
              </Grid>}
              {hasDataAndNotDisabled(formData.mediaLink) && <Grid item xs={6}>
                <MuiTextField
                  name='mediaLink'
                  // label='Media Link'
                  placeholder='Media Link'
                  onChange={(e) => onChangeHandler('mediaLink', i, e.target.value)}
                  variant='standard'
                  value={formData.mediaLink || ''}
                  disabled={mode}
                />
              </Grid>}
              {hasDataAndNotDisabled(formData.s3Name) && <Grid item xs={6}>
                <MuiTextField
                  name='s3Name'
                  // label='Media Name'
                  placeholder='Media Name'
                  onChange={(e) => onChangeHandler('s3Name', i, e.target.value)}
                  variant='standard'
                  value={formData.s3Name || ''}
                  disabled={mode}
                />
              </Grid>}
              <Grid item xs={12}>
                <Hr />
              </Grid>
            </Grid>)
        })}
        {!isFormSelectDataLoaded && <Loader />}

        <GridFooter container spacing={1}>
          {!mode && <Grid item xs={12}>
            {/* <MuiButton onClick={removeFunc} type='button' disabled={mode} color='primary' variant='contained'>Remove</MuiButton> */}
            <MuiButton onClick={addMoreFunc} type='button' disabled={mode} color='primary' variant='contained'>Add More</MuiButton>
          </Grid>}
        </GridFooter>
      </GridWrapper>
    </AccordionWithArrow>
  )
}

KeywordVibeMapping.propTypes = {
  data: PropTypes.array,
  mode: PropTypes.bool,
  onChange: PropTypes.func,
  expanded: PropTypes.bool
}

export default KeywordVibeMapping
